import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "excel-modal-header" }
const _hoisted_2 = { class: "excel-modal-tabs" }
const _hoisted_3 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_4 = { class: "tab-badge tab-badge--muted" }
const _hoisted_5 = { class: "excel-modal-body" }
const _hoisted_6 = { class: "excel-tab-panel" }
const _hoisted_7 = { class: "filter-row" }
const _hoisted_8 = { class: "excel-search-field" }
const _hoisted_9 = { class: "filter-row" }
const _hoisted_10 = { class: "filter-chips" }
const _hoisted_11 = { class: "filter-row" }
const _hoisted_12 = { class: "filter-label" }
const _hoisted_13 = { class: "filter-chips" }
const _hoisted_14 = {
  key: 0,
  class: "filter-row filter-row--sigungu"
}
const _hoisted_15 = { class: "filter-label" }
const _hoisted_16 = { class: "filter-chips" }
const _hoisted_17 = {
  key: 1,
  class: "excel-filter-hint excel-filter-hint--inline"
}
const _hoisted_18 = { class: "filter-row" }
const _hoisted_19 = { class: "filter-label" }
const _hoisted_20 = { class: "filter-chips" }
const _hoisted_21 = { class: "filter-row" }
const _hoisted_22 = { class: "filter-label" }
const _hoisted_23 = { class: "filter-range" }
const _hoisted_24 = { class: "quick-ranges" }
const _hoisted_25 = { class: "advanced-filters-grid excel-advanced-panel" }
const _hoisted_26 = { class: "adv-filter-item" }
const _hoisted_27 = { class: "adv-filter-item" }
const _hoisted_28 = { class: "adv-filter-item" }
const _hoisted_29 = { class: "adv-filter-item" }
const _hoisted_30 = { class: "eval-grade-chips" }
const _hoisted_31 = {
  key: 2,
  class: "excel-filter-hint excel-filter-hint--seed"
}
const _hoisted_32 = {
  key: 3,
  class: "excel-filter-hint"
}
const _hoisted_33 = { class: "excel-preview-panel" }
const _hoisted_34 = { class: "excel-filter-hint excel-columns-lead" }
const _hoisted_35 = {
  key: 0,
  class: "excel-preview-empty"
}
const _hoisted_36 = {
  key: 1,
  class: "excel-preview-empty"
}
const _hoisted_37 = {
  key: 2,
  class: "excel-preview-scroll"
}
const _hoisted_38 = { class: "excel-preview-table" }
const _hoisted_39 = { class: "excel-tab-panel excel-columns-panel" }
const _hoisted_40 = { class: "excel-presets" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "excel-column-groups" }
const _hoisted_43 = { class: "column-group-head" }
const _hoisted_44 = { class: "column-group-title" }
const _hoisted_45 = { class: "column-group-count" }
const _hoisted_46 = { class: "column-chip-box" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "column-chip-list" }
const _hoisted_49 = {
  key: 0,
  class: "excel-column-order-section"
}
const _hoisted_50 = { class: "order-section-head" }
const _hoisted_51 = { class: "column-order-list column-order-list--compact" }
const _hoisted_52 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_53 = { class: "order-number" }
const _hoisted_54 = { class: "column-label" }
const _hoisted_55 = { class: "excel-preview-panel" }
const _hoisted_56 = { class: "excel-filter-hint excel-columns-lead" }
const _hoisted_57 = {
  key: 0,
  class: "excel-preview-empty"
}
const _hoisted_58 = {
  key: 1,
  class: "excel-preview-empty"
}
const _hoisted_59 = {
  key: 2,
  class: "excel-preview-empty"
}
const _hoisted_60 = {
  key: 3,
  class: "excel-preview-scroll"
}
const _hoisted_61 = { class: "excel-preview-table" }
const _hoisted_62 = { class: "excel-modal-footer" }
const _hoisted_63 = { class: "footer-summary" }
const _hoisted_64 = { key: 4 }
const _hoisted_65 = { key: 5 }
const _hoisted_66 = { key: 6 }
const _hoisted_67 = {
  key: 0,
  class: "footer-limit"
}
const _hoisted_68 = { class: "footer-actions" }

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { crawlApi } from '@/services/api';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';

export interface CrawlExcelSeedFilters {
  sidoCodes?: string[];
  sigunguCode?: string | null;
  bizGubuns?: string[];
  search?: string;
  salesFilter?: string | null;
  total_capacity_min?: number | null;
  total_current_min?: number | null;
  filterHint?: string;
}

const EXCEL_ROW_LIMIT = 10000;

export default /*@__PURE__*/_defineComponent({
  __name: 'CrawlExcelDownloadDialog',
  props: {
    modelValue: { type: Boolean },
    initialFilters: { default: null }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

const dialogOpen = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
});

const excelTab = ref('filter' as 'filter' | 'columns');
const filterPreviewKeys = ['cc_name', 'sido_name', 'sigungu_name'];
const filterPreviewHeaders: Record<string, string> = {
  cc_name: '시설명',
  sido_name: '시도',
  sigungu_name: '시군구',
};
const showColumnOrder = ref(false);

const COLUMN_PRESETS: Record<string, string[]> = {
  list: ['cc_name', 'sido_name', 'sigungu_name', 'cc_biz_gubun_short', 'total_capacity', 'total_current', 'cc_tell'],
  contact: ['cc_name', 'sido_name', 'sigungu_name', 'cc_biz_gubun_short', 'cc_addr', 'cc_tell', 'cc_fax', 'cc_email'],
  staff: [
    'cc_name', 'sido_name', 'sigungu_name', 'cc_biz_gubun_short', 'cc_tell',
    'staff_total', 'staff_director', 'staff_social_worker', 'staff_nurse', 'staff_nurse_aid',
    'staff_caregiver1', 'staff_caregiver2', 'staff_pt', 'staff_ot', 'staff_dietitian', 'staff_cook', 'staff_clerk', 'staff_other',
  ],
};

const columnPresets = [
  { key: 'list', label: '목록' },
  { key: 'contact', label: '연락처' },
  { key: 'staff', label: '인력' },
];

const DEFAULT_EXCEL_COLUMNS = COLUMN_PRESETS.list;

const salesFilterOptions = [
  { label: '영업중', value: 'active' },
  { label: '회원가입성공', value: 'completed' },
  { label: '미영업', value: 'none' },
];

const excelColumns = ref<any>({ basic: [], capacity: [], staff: [] });
const selectedColumns = ref<string[]>([]);
const orderedColumns = ref<{ key: string; label: string }[]>([]);
const sidoOptions = ref<any[]>([]);
const sigunguOptions = ref<any[]>([]);
const sigunguLoading = ref(false);
const bizGubunMap = ref<any[]>([]);

const dragIndex = ref<number | null>(null);
const dragOverIndex = ref<number | null>(null);
const justMovedIndices = ref<number[]>([]);
const movedDirection = ref<Record<string, 'up' | 'down' | null>>({});

const buildEmptyFilters = () => ({
  sidoCodes: [] as string[],
  sigunguCode: null as string | null,
  bizGubuns: [] as string[],
  search: '' as string,
  salesFilter: null as string | null,
  evalGrades: [] as string[],
  staff_total_min: null as number | null,
  staff_total_max: null as number | null,
  total_capacity_min: null as number | null,
  total_capacity_max: null as number | null,
  total_current_min: null as number | null,
  total_current_max: null as number | null,
  occupancy_rate_min: null as number | null,
  occupancy_rate_max: null as number | null,
});

const excelFilters = ref(buildEmptyFilters());
const previewCount = ref(0);
const previewRows = ref<Record<string, string | number>[]>([]);
const filterPreviewRows = ref<Record<string, string | number>[]>([]);
const previewSampleLoading = ref(false);
const filterPreviewLoading = ref(false);
const excelOverLimit = computed(() => !previewLoading.value && previewCount.value > EXCEL_ROW_LIMIT);
const previewLoading = ref(false);
const downloadLoading = ref(false);
const showAdvancedFilters = ref(false);
let previewDebounceTimer: number | null = null;
let previewRequestId = 0;

const FALLBACK_BIZ_OPTIONS = [
  { label: '요양시설', value: '요양시설', color: '#0d47a1' },
  { label: '주야간보호', value: '주야간보호', color: '#F57C00' },
  { label: '방문요양', value: '방문요양', color: '#2E7D32' },
  { label: '방문목욕', value: '방문목욕', color: '#00897B' },
  { label: '방문간호', value: '방문간호', color: '#D32F2F' },
  { label: '공동생활가정', value: '공동생활가정', color: '#1565c0' },
  { label: '복지용구', value: '복지용구', color: '#607D8B' },
];

const excelBizOptions = computed(() => {
  if (bizGubunMap.value.length) {
    return bizGubunMap.value.map((m: any) => ({
      label: m.cbm_short,
      value: m.cbm_short,
      color: m.cbm_color || '#607d8b',
    }));
  }
  return FALLBACK_BIZ_OPTIONS;
});

const seedFilterHint = computed(() => props.initialFilters?.filterHint || '');

const activePreset = computed(() => {
  const current = orderedColumns.value.map((col) => col.key).join('|');
  const found = Object.entries(COLUMN_PRESETS).find(([, keys]) => keys.join('|') === current);
  return found ? found[0] : '';
});

/** 시군구 선택 가능한 단일 시도 코드 */
const selectedSidoForSigungu = computed(() => {
  const codes = excelFilters.value.sidoCodes || [];
  return codes.length === 1 ? codes[0] : null;
});

const activeFilterCount = computed(() => {
  let count = 0;
  const f = excelFilters.value;
  if (f.sidoCodes?.length) count++;
  if (f.sigunguCode) count++;
  if (f.bizGubuns?.length) count++;
  if (f.search?.trim()) count++;
  if (f.salesFilter) count++;
  if (f.evalGrades?.length) count++;
  if (f.staff_total_min != null || f.staff_total_max != null) count++;
  if (f.total_capacity_min != null || f.total_capacity_max != null) count++;
  if (f.total_current_min != null || f.total_current_max != null) count++;
  if (f.occupancy_rate_min != null || f.occupancy_rate_max != null) count++;
  return count;
});

const columnGroups = [
  { key: 'basic', label: '기본정보' },
  { key: 'capacity', label: '정원/현원' },
  { key: 'staff', label: '인력현황' },
] as const;

const columnLabels: Record<string, string> = {
  cc_number: '기관번호', cc_name: '기관명', cc_biz_gubun_short: '사업구분',
  cc_addr: '주소', sido_name: '시도', sigungu_name: '시군구',
  cc_tell: '전화번호', cc_fax: '팩스번호', cc_email: '이메일',
  cc_web: '홈페이지', cc_since: '지정일자', cc_registered: '설치신고일자',
  cc_hours: '운영시간', cc_parking: '주차시설', cc_integrated: '통합재가급여',
  eval_grade: '평가등급',
  total_capacity: '총 정원', total_current: '총 현원',
  total_waiting: '총 대기자', total_available: '총 이용가능',
  occupancy_rate: '입소율(%)',
  staff_total: '총 인원', staff_director: '시설장',
  staff_social_worker: '사회복지사', staff_nurse: '간호사',
  staff_nurse_aid: '간호조무사', staff_caregiver1: '요양보호사1급',
  staff_caregiver2: '요양보호사2급', staff_pt: '물리치료사',
  staff_ot: '작업치료사', staff_dietitian: '영양사',
  staff_cook: '조리원', staff_clerk: '사무원', staff_other: '기타',
};

const closeDialog = () => {
  dialogOpen.value = false;
};

const switchExcelTab = (tab: 'filter' | 'columns') => {
  excelTab.value = tab;
  if (tab === 'filter') fetchFilterPreview();
  if (tab === 'columns') fetchPreviewSample();
};

const applySeedToFilters = () => {
  const base = buildEmptyFilters();
  const seed = props.initialFilters;
  if (!seed) {
    excelFilters.value = base;
    return;
  }
  if (seed.sidoCodes?.length) base.sidoCodes = [...seed.sidoCodes];
  if (seed.sigunguCode) base.sigunguCode = seed.sigunguCode;
  if (seed.bizGubuns?.length) base.bizGubuns = [...seed.bizGubuns];
  if (seed.search?.trim()) base.search = seed.search.trim();
  if (seed.salesFilter) base.salesFilter = seed.salesFilter;
  if (seed.total_capacity_min != null) base.total_capacity_min = Number(seed.total_capacity_min);
  if (seed.total_current_min != null) base.total_current_min = Number(seed.total_current_min);
  excelFilters.value = base;

  if (base.total_capacity_min != null || base.total_current_min != null) {
    showAdvancedFilters.value = true;
  }
};

const loadSigunguOptions = async (sidoCode: string) => {
  sigunguLoading.value = true;
  try {
    const res = await crawlApi.getSigunguList(sidoCode);
    sigunguOptions.value = res.data?.data || [];
    if (
      excelFilters.value.sigunguCode
      && !sigunguOptions.value.some((sg: any) => sg.sigungu_code === excelFilters.value.sigunguCode)
    ) {
      excelFilters.value.sigunguCode = null;
    }
  } catch (error: any) {
    sigunguOptions.value = [];
    const message = error.response?.data?.message || error.message || '시군구 조회 실패';
    store.commit('showSnackbar', { text: message, color: 'error' });
  } finally {
    sigunguLoading.value = false;
  }
};

const ensureOptionsLoaded = async () => {
  const tasks: Promise<void>[] = [];
  if (!sidoOptions.value.length) {
    tasks.push(
      crawlApi.getSidoList().then((res) => {
        if (res.data.success) sidoOptions.value = res.data.data;
      }),
    );
  }
  if (!bizGubunMap.value.length) {
    tasks.push(
      crawlApi.getBizGubunList().then((res) => {
        bizGubunMap.value = res.data?.data || [];
      }),
    );
  }
  if (tasks.length) await Promise.all(tasks);
};

const initDialog = async () => {
  try {
    await ensureOptionsLoaded();

    const res = await crawlApi.getExcelColumns();
    if (res.data.success) {
      excelColumns.value = res.data.data;
      selectedColumns.value = [...DEFAULT_EXCEL_COLUMNS];
      orderedColumns.value = [];
      syncOrderedColumns();
    }

    applySeedToFilters();
    previewRows.value = [];
    filterPreviewRows.value = [];
    excelTab.value = 'filter';
    if (selectedSidoForSigungu.value) {
      await loadSigunguOptions(selectedSidoForSigungu.value);
    } else {
      sigunguOptions.value = [];
    }
    previewCount.value = 0;
    if (excelFilters.value.total_capacity_min == null && excelFilters.value.total_current_min == null) {
      showAdvancedFilters.value = false;
    }
    excelTab.value = 'filter';
    showColumnOrder.value = false;

    fetchPreviewCount();
    fetchFilterPreview();
  } catch (error: any) {
    console.error('엑셀 컬럼 조회 오류:', error);
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    store.commit('showSnackbar', { text: `받을 내용을 불러오지 못했습니다: ${message}`, color: 'error' });
    closeDialog();
  }
};

const getColumnLabel = (key: string): string => {
  for (const group of ['basic', 'capacity', 'staff'] as const) {
    const found = excelColumns.value[group]?.find((c: any) => c.key === key);
    if (found) return found.label;
  }
  return columnLabels[key] || key;
};

const syncOrderedColumns = () => {
  const kept = orderedColumns.value.filter(c => selectedColumns.value.includes(c.key));
  const keptKeys = new Set(kept.map(c => c.key));
  const added = selectedColumns.value
    .filter(k => !keptKeys.has(k))
    .map(k => ({ key: k, label: getColumnLabel(k) }));
  orderedColumns.value = [...kept, ...added];
};

const toggleColumn = (key: string) => {
  const idx = selectedColumns.value.indexOf(key);
  if (idx === -1) {
    selectedColumns.value = [...selectedColumns.value, key];
  } else {
    selectedColumns.value = selectedColumns.value.filter(k => k !== key);
  }
};

const getGroupSelectedCount = (group: string) => {
  const cols = excelColumns.value[group] || [];
  return cols.filter((col: any) => selectedColumns.value.includes(col.key)).length;
};

const isGroupAllSelected = (group: string) => {
  const groupColumns = excelColumns.value[group] || [];
  if (groupColumns.length === 0) return false;
  return groupColumns.every((col: any) => selectedColumns.value.includes(col.key));
};

const toggleGroupAll = (group: string) => {
  const groupColumns = excelColumns.value[group] || [];
  const groupKeys = groupColumns.map((col: any) => col.key);

  if (isGroupAllSelected(group)) {
    selectedColumns.value = selectedColumns.value.filter(key => !groupKeys.includes(key));
  } else {
    const newKeys = groupKeys.filter((key: string) => !selectedColumns.value.includes(key));
    selectedColumns.value = [...selectedColumns.value, ...newKeys];
  }
};

const toggleSidoFilter = (sidoCode: string) => {
  const idx = excelFilters.value.sidoCodes?.indexOf(sidoCode);
  if (idx === -1 || idx === undefined) {
    excelFilters.value.sidoCodes = [...(excelFilters.value.sidoCodes || []), sidoCode];
  } else {
    excelFilters.value.sidoCodes = excelFilters.value.sidoCodes.filter((c: string) => c !== sidoCode);
  }
  if (excelFilters.value.sidoCodes?.length !== 1) {
    excelFilters.value.sigunguCode = null;
    sigunguOptions.value = [];
  }
};

const selectAllSido = () => {
  if (excelFilters.value.sidoCodes?.length === sidoOptions.value.length) {
    excelFilters.value.sidoCodes = [];
  } else {
    excelFilters.value.sidoCodes = sidoOptions.value.map((s: any) => s.sido_code);
  }
  excelFilters.value.sigunguCode = null;
  sigunguOptions.value = [];
};

const toggleSigunguFilter = (sigunguCode: string) => {
  excelFilters.value.sigunguCode = excelFilters.value.sigunguCode === sigunguCode ? null : sigunguCode;
};

const clearSigunguFilter = () => {
  excelFilters.value.sigunguCode = null;
};

const setSalesFilter = (value: string) => {
  excelFilters.value.salesFilter = excelFilters.value.salesFilter === value ? null : value;
};

const applyPreset = (key: string) => {
  const keys = COLUMN_PRESETS[key];
  if (!keys) return;
  selectedColumns.value = [...keys];
  orderedColumns.value = [];
  syncOrderedColumns();
};

const toggleBizGubunFilter = (bizGubun: string) => {
  const idx = excelFilters.value.bizGubuns?.indexOf(bizGubun);
  if (idx === -1 || idx === undefined) {
    excelFilters.value.bizGubuns = [...(excelFilters.value.bizGubuns || []), bizGubun];
  } else {
    excelFilters.value.bizGubuns = excelFilters.value.bizGubuns.filter((b: string) => b !== bizGubun);
  }
};

const selectAllBizGubun = () => {
  const opts = excelBizOptions.value;
  if (excelFilters.value.bizGubuns?.length === opts.length) {
    excelFilters.value.bizGubuns = [];
  } else {
    excelFilters.value.bizGubuns = opts.map(b => b.value);
  }
};

const toggleEvalGradeFilter = (grade: string) => {
  const idx = excelFilters.value.evalGrades?.indexOf(grade);
  if (idx === -1 || idx === undefined) {
    excelFilters.value.evalGrades = [...(excelFilters.value.evalGrades || []), grade];
  } else {
    excelFilters.value.evalGrades = excelFilters.value.evalGrades.filter((g: string) => g !== grade);
  }
};

const setStaffRange = (min: number | null, max: number | null) => {
  excelFilters.value.staff_total_min = min;
  excelFilters.value.staff_total_max = max;
};

const setStaffRangeOver51 = () => setStaffRange(51, null);

const resetExcelFilters = () => {
  excelFilters.value = buildEmptyFilters();
  sigunguOptions.value = [];
  selectedColumns.value = [...DEFAULT_EXCEL_COLUMNS];
  orderedColumns.value = [];
  syncOrderedColumns();
  showAdvancedFilters.value = false;
  fetchPreviewCount();
};

const fetchPreviewCount = async () => {
  const currentRequestId = ++previewRequestId;

  try {
    previewLoading.value = true;
    const filterSnapshot = JSON.parse(JSON.stringify(excelFilters.value));
    const res = await crawlApi.previewExcel(filterSnapshot);

    if (currentRequestId !== previewRequestId) return;

    if (res.data.success) {
      previewCount.value = res.data.data.count || 0;
    }
  } catch (error: any) {
    if (currentRequestId === previewRequestId) {
      previewCount.value = 0;
      const message = error.response?.data?.message || error.message || '건수 조회 실패';
      store.commit('showSnackbar', { text: message, color: 'error' });
    }
  } finally {
    if (currentRequestId === previewRequestId) {
      previewLoading.value = false;
    }
  }
};

const debouncedFetchPreviewCount = () => {
  if (previewDebounceTimer) clearTimeout(previewDebounceTimer);
  previewDebounceTimer = window.setTimeout(() => {
    fetchPreviewCount();
    if (excelTab.value === 'filter') fetchFilterPreview();
    if (excelTab.value === 'columns') fetchPreviewSample();
  }, 500);
};

const getDownloadColumnKeys = (): string[] => {
  if (orderedColumns.value.length > 0) {
    return orderedColumns.value.map(col => col.key);
  }
  return selectedColumns.value;
};

const previewColumnKeys = computed(() => getDownloadColumnKeys());

const previewCell = (value: string | number | null | undefined) => {
  if (value == null || value === '') return '';
  return String(value);
};

let previewSampleRequestId = 0;
let filterPreviewRequestId = 0;

const fetchFilterPreview = async () => {
  const currentRequestId = ++filterPreviewRequestId;
  try {
    filterPreviewLoading.value = true;
    const filterSnapshot = JSON.parse(JSON.stringify(excelFilters.value));
    const res = await crawlApi.previewExcel(filterSnapshot, [...filterPreviewKeys]);
    if (currentRequestId !== filterPreviewRequestId) return;
    if (res.data.success) {
      previewCount.value = res.data.data.count || 0;
      filterPreviewRows.value = res.data.data.rows || [];
    }
  } catch (error: any) {
    if (currentRequestId === filterPreviewRequestId) {
      filterPreviewRows.value = [];
      const message = error.response?.data?.message || error.message || '미리보기를 불러오지 못했습니다.';
      store.commit('showSnackbar', { text: message, color: 'error' });
    }
  } finally {
    if (currentRequestId === filterPreviewRequestId) {
      filterPreviewLoading.value = false;
    }
  }
};

const fetchPreviewSample = async () => {
  const keys = getDownloadColumnKeys();
  const currentRequestId = ++previewSampleRequestId;
  if (keys.length === 0) {
    previewRows.value = [];
    previewSampleLoading.value = false;
    return;
  }

  try {
    previewSampleLoading.value = true;
    const filterSnapshot = JSON.parse(JSON.stringify(excelFilters.value));
    const res = await crawlApi.previewExcel(filterSnapshot, keys);
    if (currentRequestId !== previewSampleRequestId) return;
    if (res.data.success) {
      previewCount.value = res.data.data.count || 0;
      previewRows.value = res.data.data.rows || [];
    }
  } catch (error: any) {
    if (currentRequestId === previewSampleRequestId) {
      previewRows.value = [];
      const message = error.response?.data?.message || error.message || '미리보기를 불러오지 못했습니다.';
      store.commit('showSnackbar', { text: message, color: 'error' });
    }
  } finally {
    if (currentRequestId === previewSampleRequestId) {
      previewSampleLoading.value = false;
    }
  }
};

const onDragStart = (event: DragEvent, index: number) => {
  dragIndex.value = index;
  if (event.dataTransfer) {
    event.dataTransfer.effectAllowed = 'move';
  }
};

const onDragOver = (event: DragEvent, index: number) => {
  event.preventDefault();
  dragOverIndex.value = index;
};

const onDrop = (event: DragEvent, index: number) => {
  event.preventDefault();
  if (dragIndex.value === null || dragIndex.value === index) return;

  const fromIndex = dragIndex.value;
  const toIndex = index;
  const columns = [...orderedColumns.value];

  const originalIndices: Record<string, number> = {};
  columns.forEach((col, idx) => {
    originalIndices[col.key] = idx;
  });

  const [removed] = columns.splice(fromIndex, 1);
  columns.splice(toIndex, 0, removed);
  orderedColumns.value = columns;

  const minIdx = Math.min(fromIndex, toIndex);
  const maxIdx = Math.max(fromIndex, toIndex);
  justMovedIndices.value = [];
  for (let i = minIdx; i <= maxIdx; i++) {
    justMovedIndices.value.push(i);
  }

  movedDirection.value = {};
  columns.forEach((col, newIdx) => {
    const oldIdx = originalIndices[col.key];
    if (newIdx < oldIdx) movedDirection.value[col.key] = 'up';
    else if (newIdx > oldIdx) movedDirection.value[col.key] = 'down';
  });

  setTimeout(() => {
    justMovedIndices.value = [];
    movedDirection.value = {};
  }, 800);

  dragIndex.value = null;
  dragOverIndex.value = null;
};

const onDragEnd = () => {
  dragIndex.value = null;
  dragOverIndex.value = null;
};

const downloadExcel = async () => {
  const keys = getDownloadColumnKeys();
  if (keys.length === 0) {
    store.commit('showSnackbar', { text: '받을 내용을 하나 이상 골라 주세요.', color: 'warning' });
    excelTab.value = 'columns';
    return;
  }
  if (previewCount.value === 0) {
    store.commit('showSnackbar', { text: '조건에 맞는 시설이 없습니다.', color: 'warning' });
    return;
  }

  try {
    downloadLoading.value = true;
    await crawlApi.downloadExcel(keys, excelFilters.value);
    store.commit('showSnackbar', { text: '엑셀 다운로드가 완료되었습니다.', color: 'success' });
    closeDialog();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '다운로드 오류';
    store.commit('showSnackbar', { text: `엑셀 다운로드 실패: ${message}`, color: 'error' });
  } finally {
    downloadLoading.value = false;
  }
};

watch(() => props.modelValue, (open) => {
  if (open) initDialog();
});

watch(selectedSidoForSigungu, async (sidoCode) => {
  if (!dialogOpen.value) return;
  if (!sidoCode) {
    sigunguOptions.value = [];
    return;
  }
  await loadSigunguOptions(sidoCode);
});

watch(excelFilters, () => {
  if (dialogOpen.value) debouncedFetchPreviewCount();
}, { deep: true });

watch(selectedColumns, () => {
  if (!dialogOpen.value) return;
  syncOrderedColumns();
  if (excelTab.value === 'columns') fetchPreviewSample();
}, { deep: true });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogOpen.value,
    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((dialogOpen).value = $event)),
    "max-width": "960",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "excel-modal-card" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              size: "22",
              class: "mr-2",
              color: "#4caf50"
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode("mdi-microsoft-excel", -1)
              ]))]),
              _: 1
            }),
            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "excel-modal-title" }, "시설 데이터 엑셀 다운로드", -1)),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              icon: "",
              variant: "text",
              size: "small",
              onClick: closeDialog
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["excel-tab-btn", { active: excelTab.value === 'filter' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (switchExcelTab('filter')))
            }, [
              _createVNode(_component_v_icon, {
                size: "16",
                class: "mr-1"
              }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createTextVNode("mdi-filter-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[22] || (_cache[22] = _createTextVNode(" 조건 설정 ", -1)),
              (activeFilterCount.value > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(activeFilterCount.value), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["excel-tab-btn", { active: excelTab.value === 'columns' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (switchExcelTab('columns')))
            }, [
              _createVNode(_component_v_icon, {
                size: "16",
                class: "mr-1"
              }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createTextVNode("mdi-format-list-checks", -1)
                ]))]),
                _: 1
              }),
              _cache[24] || (_cache[24] = _createTextVNode(" 받을 내용 ", -1)),
              _createElementVNode("span", _hoisted_4, _toDisplayString(selectedColumns.value.length), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(LoadingOverlay, {
              show: downloadLoading.value,
              text: "엑셀 생성 중...",
              variant: "save"
            }, null, 8, ["show"]),
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "filter-label" }, "검색", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((excelFilters.value.search) = $event)),
                    type: "text",
                    class: "excel-search-input",
                    placeholder: "시설명, 주소, 번호"
                  }, null, 512), [
                    [_vModelText, excelFilters.value.search]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "filter-label" }, "영업", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_v_chip, {
                    size: "small",
                    class: _normalizeClass({ 'chip-selected': !excelFilters.value.salesFilter }),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (excelFilters.value.salesFilter = null))
                  }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createTextVNode(" 전체 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["class"]),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(salesFilterOptions, (opt) => {
                    return _createVNode(_component_v_chip, {
                      key: opt.value,
                      size: "small",
                      class: _normalizeClass({ 'chip-selected': excelFilters.value.salesFilter === opt.value }),
                      onClick: ($event: any) => (setSalesFilter(opt.value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(opt.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick"])
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_v_icon, {
                    size: "18",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                      _createTextVNode("mdi-map-marker", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[29] || (_cache[29] = _createTextVNode(" 시도 ", -1))
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sidoOptions.value, (sido) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      key: sido.sido_code,
                      class: _normalizeClass({ 'chip-selected': excelFilters.value.sidoCodes?.includes(sido.sido_code) }),
                      size: "small",
                      onClick: ($event: any) => (toggleSidoFilter(sido.sido_code))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(sido.sido_name), 1)
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick"]))
                  }), 128)),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    size: "x-small",
                    class: "ml-2",
                    onClick: selectAllSido
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(excelFilters.value.sidoCodes?.length === sidoOptions.value.length ? '전체 해제' : '전체 선택'), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              (selectedSidoForSigungu.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_v_icon, {
                        size: "18",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                          _createTextVNode("mdi-map-marker-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[31] || (_cache[31] = _createTextVNode(" 시군구 ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_v_chip, {
                        size: "small",
                        class: _normalizeClass({ 'chip-selected': !excelFilters.value.sigunguCode }),
                        onClick: clearSigunguFilter
                      }, {
                        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                          _createTextVNode(" 전체 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["class"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sigunguOptions.value, (sg) => {
                        return (_openBlock(), _createBlock(_component_v_chip, {
                          key: sg.sigungu_code,
                          class: _normalizeClass({ 'chip-selected': excelFilters.value.sigunguCode === sg.sigungu_code }),
                          size: "small",
                          onClick: ($event: any) => (toggleSigunguFilter(sg.sigungu_code))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(sg.sigungu_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "onClick"]))
                      }), 128))
                    ])
                  ]))
                : (excelFilters.value.sidoCodes?.length > 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                      _createVNode(_component_v_icon, {
                        size: "14",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                          _createTextVNode("mdi-information-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[34] || (_cache[34] = _createTextVNode(" 시군구는 시도를 하나만 선택했을 때 지정할 수 있습니다. ", -1))
                    ]))
                  : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_v_icon, {
                    size: "18",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                      _createTextVNode("mdi-domain", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[36] || (_cache[36] = _createTextVNode(" 사업구분 ", -1))
                ]),
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(excelBizOptions.value, (biz) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      key: biz.value,
                      class: _normalizeClass({ 'chip-selected': excelFilters.value.bizGubuns?.includes(biz.value) }),
                      style: _normalizeStyle({ '--chip-color': biz.color }),
                      size: "small",
                      onClick: ($event: any) => (toggleBizGubunFilter(biz.value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(biz.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["class", "style", "onClick"]))
                  }), 128)),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    size: "x-small",
                    class: "ml-2",
                    onClick: selectAllBizGubun
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(excelFilters.value.bizGubuns?.length === excelBizOptions.value.length ? '전체 해제' : '전체 선택'), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_v_icon, {
                    size: "18",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                      _createTextVNode("mdi-account-group", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[40] || (_cache[40] = _createTextVNode(" 직원 수 ", -1)),
                  _createVNode(_component_v_tooltip, { location: "top" }, {
                    activator: _withCtx(({ props: tooltipProps }) => [
                      _createVNode(_component_v_icon, _mergeProps(tooltipProps, {
                        size: "14",
                        class: "ml-1",
                        color: "grey"
                      }), {
                        default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                          _createTextVNode("mdi-help-circle", -1)
                        ]))]),
                        _: 1
                      }, 16)
                    ]),
                    default: _withCtx(() => [
                      _cache[39] || (_cache[39] = _createElementVNode("div", { class: "staff-tooltip" }, [
                        _createElementVNode("div", { class: "tooltip-title" }, "직원 수에 포함되는 인력:"),
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, "시설장/관리자"),
                          _createElementVNode("li", null, "사회복지사"),
                          _createElementVNode("li", null, "간호사/간호조무사"),
                          _createElementVNode("li", null, "요양보호사(1급/2급)"),
                          _createElementVNode("li", null, "물리치료사/작업치료사"),
                          _createElementVNode("li", null, "영양사/조리원"),
                          _createElementVNode("li", null, "사무원/기타")
                        ])
                      ], -1))
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_v_text_field, {
                    modelValue: excelFilters.value.staff_total_min,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((excelFilters.value.staff_total_min) = $event)),
                    modelModifiers: { number: true },
                    type: "number",
                    variant: "outlined",
                    density: "compact",
                    placeholder: "최소",
                    "hide-details": "",
                    style: {"max-width":"100px"}
                  }, null, 8, ["modelValue"]),
                  _cache[45] || (_cache[45] = _createElementVNode("span", { class: "range-separator" }, "~", -1)),
                  _createVNode(_component_v_text_field, {
                    modelValue: excelFilters.value.staff_total_max,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((excelFilters.value.staff_total_max) = $event)),
                    modelModifiers: { number: true },
                    type: "number",
                    variant: "outlined",
                    density: "compact",
                    placeholder: "최대",
                    "hide-details": "",
                    style: {"max-width":"100px"}
                  }, null, 8, ["modelValue"]),
                  _cache[46] || (_cache[46] = _createElementVNode("span", { class: "range-unit" }, "명", -1)),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_v_chip, {
                      size: "x-small",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (setStaffRange(1, 10)))
                    }, {
                      default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                        _createTextVNode("1~10명", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_chip, {
                      size: "x-small",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (setStaffRange(11, 30)))
                    }, {
                      default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                        _createTextVNode("11~30명", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_chip, {
                      size: "x-small",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (setStaffRange(31, 50)))
                    }, {
                      default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                        _createTextVNode("31~50명", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_chip, {
                      size: "x-small",
                      onClick: setStaffRangeOver51
                    }, {
                      default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                        _createTextVNode("51명 이상", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: "excel-advanced-toggle",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (showAdvancedFilters.value = !showAdvancedFilters.value))
              }, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                    _createTextVNode("mdi-tune", -1)
                  ]))]),
                  _: 1
                }),
                _cache[48] || (_cache[48] = _createTextVNode(" 추가 필터 (정원·현원·입소율·평가등급) ", -1)),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(showAdvancedFilters.value ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_v_expand_transition, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[49] || (_cache[49] = _createElementVNode("span", { class: "adv-filter-label" }, "정원", -1)),
                      _createVNode(_component_v_text_field, {
                        modelValue: excelFilters.value.total_capacity_min,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((excelFilters.value.total_capacity_min) = $event)),
                        modelModifiers: { number: true },
                        type: "number",
                        variant: "outlined",
                        density: "compact",
                        placeholder: "최소",
                        "hide-details": ""
                      }, null, 8, ["modelValue"]),
                      _cache[50] || (_cache[50] = _createElementVNode("span", null, "~", -1)),
                      _createVNode(_component_v_text_field, {
                        modelValue: excelFilters.value.total_capacity_max,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((excelFilters.value.total_capacity_max) = $event)),
                        modelModifiers: { number: true },
                        type: "number",
                        variant: "outlined",
                        density: "compact",
                        placeholder: "최대",
                        "hide-details": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[51] || (_cache[51] = _createElementVNode("span", { class: "adv-filter-label" }, "현원", -1)),
                      _createVNode(_component_v_text_field, {
                        modelValue: excelFilters.value.total_current_min,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((excelFilters.value.total_current_min) = $event)),
                        modelModifiers: { number: true },
                        type: "number",
                        variant: "outlined",
                        density: "compact",
                        placeholder: "최소",
                        "hide-details": ""
                      }, null, 8, ["modelValue"]),
                      _cache[52] || (_cache[52] = _createElementVNode("span", null, "~", -1)),
                      _createVNode(_component_v_text_field, {
                        modelValue: excelFilters.value.total_current_max,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((excelFilters.value.total_current_max) = $event)),
                        modelModifiers: { number: true },
                        type: "number",
                        variant: "outlined",
                        density: "compact",
                        placeholder: "최대",
                        "hide-details": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _cache[53] || (_cache[53] = _createElementVNode("span", { class: "adv-filter-label" }, "입소율(%)", -1)),
                      _createVNode(_component_v_text_field, {
                        modelValue: excelFilters.value.occupancy_rate_min,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((excelFilters.value.occupancy_rate_min) = $event)),
                        modelModifiers: { number: true },
                        type: "number",
                        variant: "outlined",
                        density: "compact",
                        placeholder: "최소",
                        "hide-details": ""
                      }, null, 8, ["modelValue"]),
                      _cache[54] || (_cache[54] = _createElementVNode("span", null, "~", -1)),
                      _createVNode(_component_v_text_field, {
                        modelValue: excelFilters.value.occupancy_rate_max,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((excelFilters.value.occupancy_rate_max) = $event)),
                        modelModifiers: { number: true },
                        type: "number",
                        variant: "outlined",
                        density: "compact",
                        placeholder: "최대",
                        "hide-details": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _cache[55] || (_cache[55] = _createElementVNode("span", { class: "adv-filter-label" }, "평가등급", -1)),
                      _createElementVNode("div", _hoisted_30, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['A', 'B', 'C', 'D', 'E'], (grade) => {
                          return _createVNode(_component_v_chip, {
                            key: grade,
                            class: _normalizeClass({ 'chip-selected': excelFilters.value.evalGrades?.includes(grade) }),
                            size: "small",
                            onClick: ($event: any) => (toggleEvalGradeFilter(grade))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(grade), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"])
                        }), 64))
                      ])
                    ])
                  ], 512), [
                    [_vShow, showAdvancedFilters.value]
                  ])
                ]),
                _: 1
              }),
              (seedFilterHint.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                    _createVNode(_component_v_icon, {
                      size: "14",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                        _createTextVNode("mdi-filter-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(" 현재 검색 조건이 적용되었습니다: " + _toDisplayString(seedFilterHint.value), 1)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_32, [
                    _createVNode(_component_v_icon, {
                      size: "14",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                        _createTextVNode("mdi-information-outline", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[58] || (_cache[58] = _createTextVNode(" 조건을 선택하지 않으면 전체 시설이 대상입니다. ", -1))
                  ])),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("p", _hoisted_34, [
                  _cache[59] || (_cache[59] = _createTextVNode(" 이 조건에 걸리는 시설입니다. 앞에서 8곳만 보여 줍니다. ", -1)),
                  (excelOverLimit.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("파일에는 최대 1만 곳이 들어갑니다.")
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                (filterPreviewLoading.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_35, "미리보기를 불러오는 중..."))
                  : (previewCount.value === 0 && !previewLoading.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_36, "조건에 맞는 시설이 없습니다."))
                    : (filterPreviewRows.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("table", _hoisted_38, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filterPreviewKeys, (key) => {
                                  return _createElementVNode("th", { key: key }, _toDisplayString(filterPreviewHeaders[key]), 1)
                                }), 64))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterPreviewRows.value, (row, rowIndex) => {
                                return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filterPreviewKeys, (key) => {
                                    return _createElementVNode("td", { key: key }, _toDisplayString(previewCell(row[key])), 1)
                                  }), 64))
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, excelTab.value === 'filter']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_39, [
              _cache[65] || (_cache[65] = _createElementVNode("p", { class: "excel-filter-hint excel-columns-lead" }, "엑셀에 들어갈 내용을 고르세요. 추천을 누르면 한꺼번에 골라집니다.", -1)),
              _createElementVNode("div", _hoisted_40, [
                _cache[60] || (_cache[60] = _createElementVNode("span", { class: "excel-presets-label" }, "추천", -1)),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columnPresets, (preset) => {
                  return _createElementVNode("button", {
                    key: preset.key,
                    type: "button",
                    class: _normalizeClass(["excel-preset", { active: activePreset.value === preset.key }]),
                    onClick: ($event: any) => (applyPreset(preset.key))
                  }, _toDisplayString(preset.label), 11, _hoisted_41)
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_42, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columnGroups, (group) => {
                  return _createElementVNode("div", {
                    key: group.key,
                    class: "column-group-block"
                  }, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("span", _hoisted_44, _toDisplayString(group.label), 1),
                      _createElementVNode("span", _hoisted_45, _toDisplayString(getGroupSelectedCount(group.key)) + "/" + _toDisplayString((excelColumns.value[group.key] || []).length), 1)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["column-toggle-all", { active: isGroupAllSelected(group.key) }]),
                        onClick: ($event: any) => (toggleGroupAll(group.key))
                      }, _toDisplayString(isGroupAllSelected(group.key) ? '전체 해제' : '전체 선택'), 11, _hoisted_47),
                      _createElementVNode("div", _hoisted_48, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(excelColumns.value[group.key], (col) => {
                          return (_openBlock(), _createBlock(_component_v_chip, {
                            key: col.key,
                            size: "small",
                            class: _normalizeClass({ 'chip-selected': selectedColumns.value.includes(col.key) }),
                            onClick: ($event: any) => (toggleColumn(col.key))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(col.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"]))
                        }), 128))
                      ])
                    ])
                  ])
                }), 64))
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "excel-order-toggle",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (showColumnOrder.value = !showColumnOrder.value))
              }, " 순서 " + _toDisplayString(showColumnOrder.value ? '닫기' : '바꾸기'), 1),
              (showColumnOrder.value && orderedColumns.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                          _createTextVNode("mdi-sort", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[62] || (_cache[62] = _createTextVNode(" 끌어다 놓으면 엑셀에서의 순서가 바뀝니다 ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderedColumns.value, (col, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: col.key,
                          class: _normalizeClass(["column-order-item", {
                  dragging: dragIndex.value === index,
                  'drag-over': dragOverIndex.value === index,
                  'just-moved': justMovedIndices.value.includes(index)
                }]),
                          draggable: "true",
                          onDragstart: ($event: any) => (onDragStart($event, index)),
                          onDragover: _withModifiers(($event: any) => (onDragOver($event, index)), ["prevent"]),
                          onDrop: ($event: any) => (onDrop($event, index)),
                          onDragend: onDragEnd
                        }, [
                          _createElementVNode("div", _hoisted_53, _toDisplayString(index + 1), 1),
                          _createVNode(_component_v_icon, {
                            size: "16",
                            class: "drag-handle"
                          }, {
                            default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                              _createTextVNode("mdi-drag", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("span", _hoisted_54, _toDisplayString(col.label), 1)
                        ], 42, _hoisted_52))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("p", _hoisted_56, [
                  _cache[64] || (_cache[64] = _createTextVNode(" 고른 내용이 엑셀에 이렇게 들어갑니다. 앞에서 8곳만 보여 줍니다. ", -1)),
                  (excelOverLimit.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("파일에는 최대 1만 곳이 들어갑니다.")
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                (selectedColumns.value.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_57, "받을 내용을 먼저 골라 주세요."))
                  : (previewSampleLoading.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_58, "미리보기를 불러오는 중..."))
                    : (previewCount.value === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_59, "조건에 맞는 시설이 없습니다."))
                      : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createElementVNode("table", _hoisted_61, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewColumnKeys.value, (key) => {
                                  return (_openBlock(), _createElementBlock("th", { key: key }, _toDisplayString(columnLabels[key] || key), 1))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewRows.value, (row, rowIndex) => {
                                return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewColumnKeys.value, (key) => {
                                    return (_openBlock(), _createElementBlock("td", { key: key }, _toDisplayString(previewCell(row[key])), 1))
                                  }), 128))
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
              ])
            ], 512), [
              [_vShow, excelTab.value === 'columns']
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", {
                class: _normalizeClass(["footer-count", { 'has-data': previewCount.value > 0 && !excelOverLimit.value, 'is-capped': excelOverLimit.value, loading: previewLoading.value }])
              }, [
                (previewLoading.value)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      size: "20",
                      width: "2",
                      indeterminate: "",
                      class: "mr-2"
                    }))
                  : (excelOverLimit.value)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        size: "20",
                        color: "warning",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                          _createTextVNode("mdi-alert-circle-outline", -1)
                        ]))]),
                        _: 1
                      }))
                    : (previewCount.value > 0)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 2,
                          size: "20",
                          color: "success",
                          class: "mr-2"
                        }, {
                          default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                            _createTextVNode("mdi-check-circle", -1)
                          ]))]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 3,
                          size: "20",
                          color: "warning",
                          class: "mr-2"
                        }, {
                          default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                            _createTextVNode("mdi-alert-circle-outline", -1)
                          ]))]),
                          _: 1
                        })),
                (previewLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_64, "건수 확인 중..."))
                  : (previewCount.value > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                        _createElementVNode("strong", null, _toDisplayString(previewCount.value.toLocaleString()), 1),
                        _createTextVNode("개 시설 · 내용 " + _toDisplayString(selectedColumns.value.length) + "가지 ", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_66, "조건에 맞는 시설 없음"))
              ], 2),
              (excelOverLimit.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_67, " 조건에 맞는 시설이 1만 건을 넘습니다. 파일에는 최대 1만 건만 들어갑니다. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createVNode(_component_v_btn, {
                variant: "text",
                class: "btn-cancel",
                onClick: closeDialog
              }, {
                default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                  _createTextVNode("취소", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                variant: "flat",
                class: "btn-reset",
                onClick: resetExcelFilters
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                      _createTextVNode("mdi-refresh", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[71] || (_cache[71] = _createTextVNode(" 초기화 ", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                variant: "flat",
                class: "btn-save excel-download-btn",
                loading: downloadLoading.value,
                disabled: selectedColumns.value.length === 0 || previewCount.value === 0 || previewLoading.value,
                onClick: downloadExcel
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-1",
                    size: "18"
                  }, {
                    default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                      _createTextVNode("mdi-download", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[73] || (_cache[73] = _createTextVNode(" 다운로드 ", -1))
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})